<template>
    <paper class="performanceWaybillMapMonitorWrapper">
        <div class="waybillMapMonitorWarpper">
            <!-- 左侧运单监控列表 -->
            <waybill-list
                ref="waybillList"
                @expand="isExpand = !isExpand"
                @change="handleChange"
                @clickSearch="handleClickSearch"
                :isExpand="isExpand"
                :style="isExpand ? 'width: 300px' : 'width: 36px'"
            ></waybill-list>
            <!-- 右侧地图内容区 -->
            <right-content
                ref="rightContent"
                :taskNoData="taskNoData"
                :eventList="eventList"
                :positionList="positionList"
                :ldTrackList="ldTrackList"
                :statisticsList="statisticsList"
                :taskNo="taskNo"
                :isShowPlayer.sync="isShowPlayer"
                @getTrackType="handleTrackType"
                @getLclNodeByTaskNo="getLclNodeByTaskNo"
                @getLclPointByTask="getLclPointByTask"
                :style="
                    isExpand
                        ? 'width: calc(100% - 300px)'
                        : 'width: calc(100% - 36px)'
                "
            ></right-content>
        </div>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import WaybillList from './component/WaybillList.vue';
import RightContent from './component/RightContent.vue';
import { queryEventList, queryPositionList, queryLdTrackList, queryPlanLine, getPosition, getMonitorStatisticsList  } from '../../../api/performanceWaybillMapMonitor.js';
import { formatPositionList, validateTakeOrderTime, formatStatisticsList  } from './util/util.js';
export default {
    name: 'waybillMapMonitor',
    components: {
        paper,
        WaybillList,
        RightContent
    },
    data () {
        return {
            isExpand: true, // 是否收缩左侧列表
            taskNo: '', // 运输单号
            eventList: [], // 事件管理列表
            positionList: [], // 定位信息列表
            ldTrackList: [], // 零担平台运单状态列表
            planListData: {}, // 地图计划线信息
            carPositionInfo: {}, // 当前车辆定位信息
            statisticsList: [], // 打点统计信息
            isShowPlayer: false, // 是否展示轨迹回放
            transportId: 0,
            isShowTakeOrderPoint: false, // 是否展示接单点
            shippingType: 0, // 发运类型
            takeOrderTrackingDate: '', // 接单点时间
            realDepartureTime: '', // 发车时间
            taskNoData: {}, // TK单数据
            isShowCarIcon: false // 是否展示车辆图标
        };
    },
    mounted () {
        this.viewTrack();
    },
    methods: {
        // 补抓专线节点回调函数
        getLclNodeByTaskNo () {
            this.getLdTrackList(this.transportId);
        },
        // 补拉北斗轨迹回调函数
        getLclPointByTask () {
            this.getPositionList(this.transportId, '6');
            this.updateMap();
        },
        /**
         * @description 获取事件管理列表
         * @param {Number} transportId 监控列表项id
         */
        getEventList (transportId) {
            return queryEventList({ transportId }).then(res => {
                if (res && +res.code === 0) {
                    this.taskNo = res.data.taskNo || '';
                    this.eventList = res.data.events || [];
                }
            });
        },

        /**
         * @description 获取定位信息列表
         * @param {Number} transportId 监控列表项id
         */
        getPositionList (transportId, trackingType) {
            return queryPositionList({ transportId, trackingType }).then(res => {
                if (res && +res.code === 0) {
                    this.positionList = formatPositionList(res.data || []);
                    // 有打点数据，就绘制轨迹，展示轨迹回放功能
                    if (this.positionList.length) {
                        this.isShowPlayer = true;
                        this.takeOrderTrackingDate = this.positionList[this.positionList.length - 1].trackingDate || '';
                    } else {
                        this.isShowPlayer = false;
                        this.$message.warning('当前无轨迹信息！');
                    }
                }
            });
        },
        /**
         * @description 选择轨迹来源回调函数
         * @param {Number} trackType 轨迹分类
         */
        handleTrackType (trackType) {
            // 重置定位信息列表和轨迹回放
            this.positionList = [];
            this.isShowPlayer = false;
            this.isShowTakeOrderPoint = false;
            // 必须选中左侧运单，切换轨迹才会触发查询以及右侧地图事件
            this.transportId && this.handleInitData({ id: this.transportId, shippingType: this.shippingType }, trackType);
        },
        /**
         * @description 获取零担平台运单状态列表
         * @param {Number} transportId 监控列表项id
         */
        getLdTrackList (transportId) {
            return queryLdTrackList({ transportId }).then(res => {
                if (res && +res.code === 0) {
                    this.ldTrackList = res.data.tracks || [];
                }
            });
        },

        /**
         * @description 查询地图计划线
         * @param {Number} transportId 监控列表项id
         */
        getMapPlanLine (transportId) {
            return queryPlanLine({ transportId }).then(res => {
                if (res && +res.code === 0) {
                    this.planListData = res.data.length ? res.data[0] : {};
                    this.realDepartureTime = this.planListData.realDepartureTime || '';
                    // 运单状态为已抵达(50, 55, 60, 70, 75, 80,100,200,999)不需要展示货车图标
                    if (res.data.length) {
                        this.isShowCarIcon = ![50, 55, 60, 70, 75, 80, 100, 200, 999].includes(+res.data[0].taskStatus);
                    }
                }
            });
        },

        /**
         * @description 查询当前车辆定位
         * @param {Number} transportId 监控列表项id
         */
        getCarPosition (transportId) {
            return getPosition({ transportId }).then(res => {
                if (res && +res.code === 0) {
                    this.carPositionInfo = res.data || {};
                }
            });
        },
        /**
         * @description 获取打点统计信息
         * @param {Number} transportId 监控列表项id
         */
        getMonitorStatisticsList (transportId) {
            return getMonitorStatisticsList({ transportId }).then(res => {
                if (res && +res.code === 0) {
                    this.statisticsList = formatStatisticsList(res.data || []);
                }
            }).catch(() => {});
        },
        /**
         * @description 点击左侧列表项回调
         * @param {Object} data 当前操作列表项数据
         */
        handleChange (data) {
            this.taskNoData = data;
            this.$refs.rightContent.mapLoading = true;
            this.transportId = data.id;
            this.shippingType = data.shippingType;
            // trackType = '50': 默认查询轨迹来源为综合的定位信息
            this.$refs.rightContent.trackType = '50';
            this.isShowTakeOrderPoint = false;
            this.isShowCarIcon = false;
            this.handleInitData(data);
        },
        handleInitData (data, trackType = '50') {
            Promise.all([
                this.getEventList(data.id),
                this.getPositionList(data.id, trackType),
                this.getLdTrackList(data.id),
                this.getMapPlanLine(data.id),
                this.getCarPosition(data.id),
                this.getMonitorStatisticsList(data.id)
            ]).then(() => {
                // 接单点显示逻辑
                if (validateTakeOrderTime(data.shippingType, trackType, this.takeOrderTrackingDate, this.realDepartureTime)) {
                    this.isShowTakeOrderPoint = true;
                }
                this.$refs.rightContent.mapLoading = false;
                this.updateMap();
            });
        },
        // 更新地图
        updateMap () {
            this.$refs.rightContent.initMap({
                planListData: this.planListData, // 查询计划线(起点-终点)
                positionList: this.positionList || [], // 车辆定位数据列表
                carPositionInfo: this.carPositionInfo || {}, // 当前车辆定位信息
                isShowTakeOrderPoint: this.isShowTakeOrderPoint, // 是否展示接单点
                isShowCarIcon: this.isShowCarIcon // 是否展示车辆图标
            });
        },
        handleClickSearch () {
            !this.isExpand && (this.isExpand = true);
        },
        // 查看运单轨迹
        viewTrack () {
            const param = this.$route.query;
            // 路由携带taskNo 或 dispatchNo参数时，查询对应运单轨迹，反之初始化查询
            this.$nextTick(() => {
                if (Object.keys(param).length) {
                    this.$refs.waybillList.search(param);
                } else {
                    this.$refs.waybillList.getList();
                }
            });
        }
    },
    beforeRouteEnter (to, from, next) {
        // 判断是否从运单管理或在途预警进入
        if (from.path === '/otp/distribute/vehicle-transit-warning') {
            next(vm => {
                vm.viewTrack();
            });
        } else {
            next();
        }
    }
};
</script>
<style scoped lang="less">
.performanceWaybillMapMonitorWrapper {
    padding: 0;
    margin: 0;
    .waybillMapMonitorWarpper {
        height: 100%;
        display: flex;
    }
}
</style>
